// extracted by mini-css-extract-plugin
export var hidden = "_tj-0";